import { CREATE_LOT, GET_LOT, LOT_REQUEST, DELETE_LOT, UPDATE_LOT, LOT_REQUEST_FAILURE } from "../types";

const initialState = {
  lots: [],
  loading: false,
  error: null,
};

const lotReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_LOT: {
      return {
        ...state,
        lots: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_LOT:
      return {
        ...state,
        lots: [action.payload, ...state.lots],
        loading: false,
        error: null
      };
    case UPDATE_LOT:
      const lotsData = state.lots.slice(0);
      const uIndex = lotsData.findIndex((data) => data.id === action.payload.id);
      lotsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        lots: [ ...lotsData ],
        loading: false,
        error: null
      };
    case DELETE_LOT:
      const lots = state.lots?.slice(0);
      const index = lots.findIndex((data) => data.id === action.id);
      if (index > -1) {
          lots.splice(index, 1);
      }
      return {
        ...state,
        lots: [...lots],
        loading: false,
        error: null
      }
    case LOT_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default lotReducer